import { makeStyles } from '@material-ui/core';

import { DataProtectionOptInField } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/components/DataProtectionOptInField';
import { Font } from '@/components/shared/components/Font';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

export const ShortContactFormFields = () => {
  return (
    <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
      <TextFormField
        autoFocus
        name={'firstName'}
        label={'FIRST_NAME'}
        labelSuffix={<DocumentMatchLabelSuffix />}
        fieldVariant={FieldVariant.form}
      />
      <TextFormField
        name={'lastName'}
        label={'LAST_NAME'}
        labelSuffix={<DocumentMatchLabelSuffix />}
        fieldVariant={FieldVariant.form}
      />
      <PhoneFormDoubleField
        fieldVariant={FieldVariant.form}
        availableCountriesIso2={['ES']}
        phoneNumber={{ name: 'phoneNumber', fieldProps: { label: 'MOBILE_PHONE_NUMBER' } }}
      />
      <TextFormField name={'email'} label={'MAIL'} fieldVariant={FieldVariant.form} />
      <TextFormField name={'documentNumber'} label={'IBERIA_CARDS_STANDS_DOCUMENT_NUMBER'} fieldVariant={FieldVariant.form} />
      <DataProtectionOptInField />
    </FormGridContainer>
  );
};

const useStyles = makeStyles({
  suffix: {
    opacity: 0.5,
    paddingLeft: '0.5em',
    whiteSpace: 'nowrap',
  },
});

const DocumentMatchLabelSuffix = () => {
  const classes = useStyles();

  return (
    <Font variant={'subtitle2'} color={'textSecondary'} className={classes.suffix}>
      {'('}
      <Text tId={'IBERIA_CARDS_STANDS_DOCUMENT_MATCH_HINT'} />
      {')'}
    </Font>
  );
};
